import { render, staticRenderFns } from "./facturAccompte.vue?vue&type=template&id=81710adc&scoped=true"
import script from "./facturAccompte.vue?vue&type=script&lang=js"
export * from "./facturAccompte.vue?vue&type=script&lang=js"
import style0 from "./facturAccompte.vue?vue&type=style&index=0&id=81710adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81710adc",
  null
  
)

export default component.exports